/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Open_Screen_ExpiredInputs */

const en_us2_chat_open_screen_expired = /** @type {(inputs: Chat_Open_Screen_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That plan is no longer available. Ask for a new one.`)
};

const pt_br2_chat_open_screen_expired = /** @type {(inputs: Chat_Open_Screen_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse plano não está mais disponível. Peça um novo.`)
};

const es_419_chat_open_screen_expired = /** @type {(inputs: Chat_Open_Screen_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese plan ya no está disponible. Pide uno nuevo.`)
};

const pt_pt2_chat_open_screen_expired = /** @type {(inputs: Chat_Open_Screen_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse plano já não está disponível. Pede um novo.`)
};

const fr_fr2_chat_open_screen_expired = /** @type {(inputs: Chat_Open_Screen_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce programme n'est plus disponible. Demandes-en un nouveau.`)
};

const de_de2_chat_open_screen_expired = /** @type {(inputs: Chat_Open_Screen_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Plan ist nicht mehr verfügbar. Bitte um einen neuen.`)
};

const it_it2_chat_open_screen_expired = /** @type {(inputs: Chat_Open_Screen_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa scheda non è più disponibile. Chiedine una nuova.`)
};

/**
* | output |
* | --- |
* | "That plan is no longer available. Ask for a new one." |
*
* @param {Chat_Open_Screen_ExpiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const chat_open_screen_expired = /** @type {((inputs?: Chat_Open_Screen_ExpiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Open_Screen_ExpiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_chat_open_screen_expired(inputs)
	if (locale === "es-419") return es_419_chat_open_screen_expired(inputs)
	if (locale === "pt-PT") return pt_pt2_chat_open_screen_expired(inputs)
	if (locale === "fr-FR") return fr_fr2_chat_open_screen_expired(inputs)
	if (locale === "de-DE") return de_de2_chat_open_screen_expired(inputs)
	if (locale === "it-IT") return it_it2_chat_open_screen_expired(inputs)
	return en_us2_chat_open_screen_expired(inputs)
});
export { chat_open_screen_expired as "chat.open_screen.expired" }